import type { PaymentMethod, StatusType } from "../../Enums/RegistrationEnum";
import type { IEvent } from "../../interfaces/models/IEvent";
import type { IRegistration, IRegistrationGuest } from "../../interfaces/models/IRegistration";
import type { IPayment } from "../../interfaces/models/IPayment";
import IFirm from "../../interfaces/models/IFirm";
import type { AuditLog } from "../../interfaces/models/IAudityLogs";
import type { SpecialEventGuestsMap } from "../../utils/specialEventGuests";
import type { PaymentHistoryRow, RegistrantHistoryRow } from "../../pages/Events/EditParticipant/types";

import type { RegistrantCatalogOption } from "../../pages/Events/EditParticipant/hooks/useRegistrantCatalogOptions";

export type EditParticipantCatalogState = {
  organizationLabel: string;
  organizationOptions: RegistrantCatalogOption[];
  registrantOptions: RegistrantCatalogOption[];
};

export type EditParticipantPersistedPaymentFields = {
  amountPaid?: number;
  additionalFee?: number;
  paymentMethod?: PaymentMethod;
  paymentStatus?: StatusType;
};

export type EditParticipantState = {
  meta: {
    eventId: string;
    registrationId?: string;
    isEditMode: boolean;
    activeTab: number;
    hasSavedOnce: boolean;
    tabs: string[];
  };
  data: {
    eventData?: IEvent;
    registrationData?: IRegistration;
    paymentData?: IPayment;
    payments: IPayment[];
    firmData?: IFirm;
    loading: boolean;
  };
  form: {
    isRegistrantModifyMode: boolean;
    guests: IRegistrationGuest[];
    selectedSpecialEventIds: string[];
    specialEventGuestsMap: SpecialEventGuestsMap;
    additionalFeeInput: string;
    newPaymentDateMs: number | null;
    newPaymentAmount: string;
    newPaymentMethod: PaymentMethod | "";
    newPaymentNote: string;
    refunded: boolean;
    amountRefunded: string;
    applyFirmCredit: boolean;
    creditPayment: string;
    ccName: string;
    ccEmail: string;
    showGuestValidationErrors: boolean;
    persistedPaymentFields: EditParticipantPersistedPaymentFields;
    autoPrepaidLocked: boolean;
  };
  audit: {
    auditLogs: AuditLog[];
    auditHistoryExpanded: boolean;
    isLoadingAuditLogs: boolean;
    registrantHistoryRows: RegistrantHistoryRow[];
    paymentHistoryRows: PaymentHistoryRow[];
  };
  save: {
    isSaving: boolean;
  };
  catalog: EditParticipantCatalogState;
};

export const EditParticipantEmpty: EditParticipantState = {
  meta: {
    eventId: "",
    registrationId: undefined,
    isEditMode: false,
    activeTab: 0,
    hasSavedOnce: false,
    tabs: ["REGISTRATION", "SEND EMAIL INVOICE"],
  },
  data: {
    payments: [],
    loading: false,
  },
  form: {
    isRegistrantModifyMode: true,
    guests: [],
    selectedSpecialEventIds: [],
    specialEventGuestsMap: {},
    additionalFeeInput: "",
    newPaymentDateMs: Date.now(),
    newPaymentAmount: "",
    newPaymentMethod: "",
    newPaymentNote: "",
    refunded: false,
    amountRefunded: "0",
    applyFirmCredit: false,
    creditPayment: "0",
    ccName: "",
    ccEmail: "",
    showGuestValidationErrors: false,
    persistedPaymentFields: {},
    autoPrepaidLocked: false,
  },
  audit: {
    auditLogs: [],
    auditHistoryExpanded: false,
    isLoadingAuditLogs: false,
    registrantHistoryRows: [],
    paymentHistoryRows: [],
  },
  save: {
    isSaving: false,
  },
  catalog: {
    organizationLabel: "Firm",
    organizationOptions: [],
    registrantOptions: [],
  },
};
